module.exports = __webpack_public_path__ + "img/registration-06.46fd9f9b.png";